module.exports = __webpack_public_path__ + "img/der_01_aim.739ab007.svg";